module.exports = __webpack_public_path__ + "static/media/pi.d0aa2112.png";